import { useEffect } from 'react';
import {
	clearShowOldEditorSucccessFlag,
	getShouldShowOldEditorSucccessFlag,
} from './getShouldShowOldEditorSucccessFlag.tsx';
import { useChangePreferenceFlag } from './useChangePreferenceFlag.tsx';

// Show flag when show old editor flag is true in session storage
export const useChangeToOldEditorSuccessFlag = ({
	openDefaultEditorDialog,
}: {
	openDefaultEditorDialog: () => void;
}): {
	showOldEditorSuccessFlag: (openDefaultEditorDialog?: () => void) => string | undefined;
} => {
	const { showOldEditorSuccessFlag } = useChangePreferenceFlag();

	useEffect(() => {
		if (getShouldShowOldEditorSucccessFlag()) {
			clearShowOldEditorSucccessFlag();
			showOldEditorSuccessFlag(openDefaultEditorDialog);
		}
	}, [openDefaultEditorDialog, showOldEditorSuccessFlag]);

	return { showOldEditorSuccessFlag };
};
